import type { Activity, GraduateYear, ListResponse, NewsPost, PublicHome } from './types';

export type PublicApi = ReturnType<typeof createPublicApi>;

export function createPublicApi(baseUrl: string, request: typeof fetch = fetch) {
  const base = baseUrl.replace(/\/$/, '');

  async function get<T>(path: string): Promise<T> {
    const response = await request(`${base}${path}`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`HTL public API returned ${response.status}`);
    return response.json() as Promise<T>;
  }

  return {
    home: () => get<{ data: PublicHome }>('/home').then((r) => r.data),
    activities: () => get<ListResponse<Activity>>('/activities').then((r) => r.data),
    graduates: () => get<ListResponse<GraduateYear>>('/graduates').then((r) => r.data),
    news: () => get<ListResponse<NewsPost>>('/news'),
    post: (slug: string) => get<{ data: NewsPost }>(`/news/${encodeURIComponent(slug)}`).then((r) => r.data),
  };
}

